import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';
import { throwErrorWithId } from '@pypestream/utils';

import { checkForErrors } from '../../utils';
import { ProStudioContext, ProStudioEvents } from '../prostudio.xstate.types';
import { SolutionVersion } from '@pypestream/api-services/urql';

export const refetchSolutionData = async (
  _ctx: ProStudioContext,
  event: ProStudioEvents
): Promise<{
  draftVersionSolutionData: SolutionVersion | null;
  cb?: (
    updatedSolutionData: ProStudioContext['draftVersionSolutionData']
  ) => void;
} | void> => {
  if (event.type !== 'refetchSolutionData') {
    return;
  }

  const { solutionVersionId, cb } = event.payload;

  if (!solutionVersionId) {
    throwErrorWithId('Solution version ID is required');
    return;
  }

  const solutionResponse = await urqlGql.getSolutionVersionById({
    solutionVersionByIdId: solutionVersionId,
  });

  checkForErrors(solutionResponse);

  const updatedSolutionData =
    solutionResponse.data?.admin_?.solutionVersionById;

  console.log('REFETCH_SOLUTION_DATA_RESPONSE', updatedSolutionData);

  return {
    draftVersionSolutionData: updatedSolutionData as SolutionVersion,
    cb: cb ? () => cb(updatedSolutionData as SolutionVersion) : undefined,
  };
};
